/// <reference path='../_all.ts' />

module blog {
  'use strict';

  export class EventCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
      'blogService',
      '$timeout',
      '$filter', 
    ];

    constructor(
      private $scope: IEventCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
      private blogService: IBlogService,
      private $timeout: ng.ITimeoutService,
      private $filter: ng.IFilterService
    ) {
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.loadedBlogEntries = [];
      $scope.tags = [];
      $scope.entriesToLoad = 500;
      $scope.hideFooterButton = false;
      
      $scope.years = [];

      this.getMoreTopics();
      
      
    }


    getMoreTopics() {
      this.blogService.loadTopicRange(this.$scope.loadedBlogEntries.length, this.$scope.entriesToLoad, "events", this.$scope.tags, false, false).then((response) => {
        var years: { [id: number] : number; } = {};
        var isFuterEvent = this.isFutureEvent();

        response.data.forEach((element) => {
          this.$scope.loadedBlogEntries.push(element);

          element.ContentMeta.ValidFrom = new Date(<any>element.ContentMeta.ValidFrom); //from the api comes a string, typescript thinks its a date.
          element.ContentMeta.ValidTo = new Date(<any>element.ContentMeta.ValidTo);

          if (isFuterEvent(element)) { 
            if (!years[element.ContentMeta.ValidFrom.getFullYear()]) years[element.ContentMeta.ValidFrom.getFullYear()] = element.ContentMeta.ValidFrom.getFullYear();

            // open links in new window
            var tree = angular.element('<div>' + element.ContentHtml + '</div>');
            tree.find('a').attr('target', '_blank');
            element.ContentHtml = angular.element('<div>').append(tree).html();
          }
                             
        })
        // wenn keine mehr => button ausblenden
        if (response.data.length < this.$scope.entriesToLoad) {
          this.$scope.hideFooterButton = true;
        }

        this.$scope.years = [];
        for (var year in years) this.$scope.years.push(years[year]); 
        this.$scope.years.sort();

      })
    }

    getDateRange(dateFrom : Date, dateTo: Date) {
      var datestr : string = "";

      if (!dateFrom && !dateTo) return null;

      if (!dateFrom) dateFrom = dateTo
      if (!dateTo) dateTo = dateFrom

      // Freitag 5. April 2008
      if (dateFrom == dateTo) {
        datestr += this.$filter('date')(dateFrom, "dddd dd. MMMM yyyy", "+02") + " ";
        return datestr;
      }

      // 1. - 5. April 2008
      if (dateFrom.getMonth() == dateTo.getMonth() && dateFrom.getFullYear() == dateFrom.getFullYear()) {
        datestr += dateFrom.getDate() + ".\u202F–\u202F";
        datestr += dateTo.getDate() + ". ";
        datestr += this.$filter('date')(dateTo, "MMMM ", "+02") ;
        datestr += dateFrom.getFullYear();
        return datestr
      }

      //31. März - 2.April 2008
      if (dateFrom.getFullYear() == dateFrom.getFullYear()) {
        datestr += this.$filter('date')(dateFrom, "d. MMMM ", "+02");
        datestr += "\u202F–\u202F";
        datestr += this.$filter('date')(dateTo, "d. MMMM ", "+02");
        datestr += dateFrom.getFullYear();
        return datestr;
      }

      // 28.12.2008 - 07.01.2009
      datestr += this.$filter('date')(dateTo, 'shortDate', "+02");
      datestr += "\u202F–\u202F";
      datestr += this.$filter('date')(dateTo, 'shortDate', "+02");
      return datestr;
    }

    getTopicRange() {
      this.blogService.loadTopicRange(0, this.$scope.entriesToLoad, "events", this.$scope.tags, false, false).then((response) => {
        this.$scope.loadedBlogEntries = response.data;
      })
    }

    isFutureEvent() {
      var todayPlus2 : Date = new Date()
      todayPlus2.setDate(todayPlus2.getDate() + 1);
      return function( content: editor.Content ) {        
        return content.ContentMeta.ValidTo.getFullYear() < 3000 && content.ContentMeta.ValidTo > todayPlus2;
      };
    }

    isInYear(year : number) {      
      return function( content: editor.Content ) {        
        return content.ContentMeta.ValidFrom.getFullYear() == year;
      };
    }

    
    getImgSrc(entry: editor.Content): string {
      if (entry.ContentMeta.Image) {
        return "/svc/blogressource.axd?id=" + entry.ContentFilter.ContentId + "&type=1&lang=" + pglob.RouteData.CurrentLanguage.hl;
      } else {
        return "";
      }
    }
  }
}